import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./theme/ThemeContext";
import "./index.css";
// Shared components can be pulled into several independent lazy chunks. Keep
// their styles in one deterministic entry order so the production extractor
// never has to guess an order between those chunks.
import "./components/HelpfulEmptyState.css";
import "./components/SellerQuickProfile.css";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import App from "./App";
import RouteScrollReset from "./components/RouteScrollReset";
import "./TempleUltraPremium.css";
import "./PremiumRefinement.css";
import "./components/NavigationPremium.css";
import { NotificationAudioProvider } from "./context/NotificationAudioContext";
import { WalletProvider } from "./wallet/WalletContext";
import { FeatureRegistryProvider } from "./feature-status/FeatureRegistryContext";
import { registerEternuaServiceWorker } from "./pwa/pwa";
import PwaRuntime from "./pwa/PwaRuntime";
import { NotificationCenterRuntime } from "./notifications/NotificationFeatureGate";
import { installSecureRequestDefaults } from "./security/secureFetch";
import reportWebVitals from "./reportWebVitals";

installSecureRequestDefaults();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* Router global */}
    <BrowserRouter>
      <RouteScrollReset />
      {/* Thème global clair / sombre */}
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <WalletProvider>
              <NotificationAudioProvider>
                <FeatureRegistryProvider>
                  <NotificationCenterRuntime>
                    <App />
                    <PwaRuntime />
                  </NotificationCenterRuntime>
                </FeatureRegistryProvider>
              </NotificationAudioProvider>
            </WalletProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

registerEternuaServiceWorker();

reportWebVitals((metric) => {
  const safeMetric = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    path: window.location.pathname,
  };
  window.__eternuaWebVitals = [...(window.__eternuaWebVitals || []).slice(-19), safeMetric];
  window.dispatchEvent(new CustomEvent("eternua:web-vital", { detail: safeMetric }));
});
